import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardTitle, InputGroupAddon } from 'reactstrap';
import { useFormikContext } from 'formik';
import { Field, Input } from '@availity/form';
import { SelectField } from '@availity/select';
// import { FormikSwitch } from '@/components';
import { SwitchButton } from '@/components';

const creatableListFilters = [
  'postalCode',
  'vendorSubID',
  'vendorPubID',
  'vendorLandingPage',
  'domain',
  'vendorSource',
  'activeProspectOperatingSystem',
  'activeProspectIp',
  'activeProspectDevice',
  'activeProspectPageUrl',
  'activeProspectParentPageURL',
  'activeProspectPageID',
  'activeProspectFormInputMethod',
  'activeProspectFramed',
  'activeProspectCountryCode',
  'activeProspectBrowser',
  'activeProspectTimeZone',
  'activeProspectDomain',
];

const overideDuplicateChecksOptions = [
  { value: 'vendorLandingPage', label: 'Landing Page' },
  { value: 'domain', label: 'Domain' },
];

const OtherCard: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<{
    isCampaignDestination: boolean;
    verifyDestination: boolean;
    skipActiveDemandSubmit: boolean;
    allowMLOverride: boolean;
    overideDuplicateChecks: boolean;
    isUpdateEligible: boolean;
    allowAPOnPing: boolean;
    allowSlices: boolean;
    allowMLearning: boolean;
    mlVersion: any;
    smartPriceAcceptence: boolean;
    dupPriceThreashold: number;
    dupPriceThreasholdLookBack: number;
    allowSplits: boolean;
    useEventsMLModel: boolean;
    allowMLPriceOverride: boolean;
    minAcceptenceBid: number;
    mlTargetMaxPrice: number;
    mlTargetMinPrice: number;
    mlTargetConversionRate: number;
    mlProbablityIncreasePercentage: number;
    mlProbablityIncreasePerLead: number;
    mlAggressionConversionLevel: number;
    mlAggressionPriceLevel: number;
    mlBeforeThreashold: boolean;
    allowAdvanceFitering: boolean;
    doNotAcceptQualityRejects: boolean;
    splitStopActiveDemand: boolean;
    splitStopCountMinActiveDemand: number;
    splitActiveDemandFallBack: string[];
    mlNetworkOptimized: boolean;
    mlCPATarget: number;
    dupCheckLevelID: string;
    adIncomeMax: number;
    adHouseHoldMax: number;
    applyOverrideFilter: boolean;
    agentProfileAssigmentAllowed: boolean;
  }>();
  const { setFieldTouched } = useFormikContext();
  const [tempFlag, setTempFlag] = useState(values.isCampaignDestination);

  // useEffect() Need to know when form is done saving to change switch message or need to do someting different

  return (
    <>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Active Demand Skip Threasholds
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            {/* <FormikSwitch
            name="isCampaignDestination"
            label="Turn On"
            helpMessage="Show this lead source as a destination when creating a marketplace campaign"
          /> */}
            <SwitchButton
              disabled={tempFlag}
              width={120}
              checked={values.isCampaignDestination}
              onlabel={!tempFlag ? 'Pending' : 'Active'}
              offlabel="Create"
              onstyle="success"
              offstyle="primary"
              onChange={() => {
                setFieldValue(
                  'isCampaignDestination',
                  (values.isCampaignDestination = !values.isCampaignDestination)
                );
              }}
            />
          </Col>
        </Row>
      </Card>

      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Verify Destination
        </CardTitle>
        <div id="live-transfers-switch-button">
          <SwitchButton
            width={100}
            checked={!!values.verifyDestination}
            onlabel="Enabled"
            offlabel="Disabled"
            onstyle="success"
            offstyle="danger"
            onChange={() =>
              setFieldValue('verifyDestination', !values.verifyDestination)
            }
          />
        </div>
      </Card>

      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Skip Active Demand on Submit Requests
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.skipActiveDemandSubmit}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'skipActiveDemandSubmit',
                  !values.skipActiveDemandSubmit
                )
              }
            />
          </Col>
        </Row>
      </Card>

      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Active Demand Settings
        </CardTitle>
        <Row>
          <Col xs={7} className="mt-3">
            <Field
              id="lead-max-demand-unsold-accepted"
              name="maxDemandUnsoldAccepted"
              label="Unsold with Active Demand On"
              type="number"
              onBlur={({ target: { value } }) => {
                setFieldValue('maxDemandUnsoldAccepted', parseInt(value, 10));
                setFieldTouched('maxDemandUnsoldAccepted', true, true);
              }}
              helpMessage="Set the max number of leads accepted and unsold until activating active demand"
            />
          </Col>
        </Row>
      </Card>

      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Update Lead Data Eligible
        </CardTitle>
        <Row>
          <Col xs={6} className="mt-3 ml-3">
            <Row className="mb-1">
              <SwitchButton
                width={120}
                checked={values.isUpdateEligible}
                onlabel="On"
                offlabel="Off"
                onstyle="success"
                offstyle="primary"
                onChange={() => {
                  setFieldValue(
                    'isUpdateEligible',
                    (values.isUpdateEligible = !values.isUpdateEligible)
                  );
                }}
              />
            </Row>
            <Row>
              <Field
                id="delay-seconds-for-update"
                name="delaySecondsForUpdate"
                label="Delay Seconds For Update"
                type="number"
                onBlur={({ target: { value } }) => {
                  setFieldValue('delaySecondsForUpdate', parseInt(value, 10));
                }}
                helpMessage="Set the delay in seconds to wait for more information on the lead"
              />
            </Row>
          </Col>
        </Row>
      </Card>

      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Override Duplicate Rejects
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.overideDuplicateChecks}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'overideDuplicateChecks',
                  !values.overideDuplicateChecks
                )
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Allow AP On Pings
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.allowAPOnPing}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('allowAPOnPing', !values.allowAPOnPing)
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Smart Price Acceptence
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.smartPriceAcceptence}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'smartPriceAcceptence',
                  !values.smartPriceAcceptence
                )
              }
            />
          </Col>
        </Row>
        <Row className="mt-3 ml-1">
          <p>
            When using smart acceptence, only phone duplicate checks are
            applied. Any other duplicate check will be ignored on this layer
          </p>
        </Row>
      </Card>

      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Corporate Duplicate Check Override
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={3}>
            <Field
              id="dup-price-threashold"
              name="dupPriceThreashold"
              label="Duplicate Override Price"
              type="number"
              min={0}
              step="0.01"
              onBlur={({ target: { value } }) => {
                setFieldValue('dupPriceThreashold', parseFloat(value, 0));
              }}
              helpMessage="Set the max price to allow a corp dup check override."
            />
          </Col>
          <Col xs={3}>
            <Field
              id="dup-price-threashol-lookback"
              name="dupPriceThreasholdLookBack"
              label="Duplicate Override Look Back"
              type="number"
              min={0}
              step="1"
              onBlur={({ target: { value } }) => {
                setFieldValue(
                  'dupPriceThreasholdLookBack',
                  parseFloat(value, 0)
                );
              }}
              helpMessage="Set look back days for the company check on a corp dup check override"
            />
          </Col>
        </Row>
      </Card>

      <Card body className="mt-3 mb-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Corp or GTB Dup Check Override
        </CardTitle>
        <Row>
          <Col xs={2} className="ml-4">
            <SelectField
              id="attribute-static-list-filter-values"
              name="overrideBlockedAttributeFields"
              options={overideDuplicateChecksOptions}
              label="Attribute"
              onChange={(val: any) => {
                setFieldValue('overrideBlockedAttributeFields', val);
              }}
              // labelKey="label"
              // valueKey="value"
              raw
            />
          </Col>
          <Col xs={5} className="ml-4">
            <SelectField
              id="attribute_val-static-list-filter-values"
              name="overrideBlockedValues"
              options={[]}
              label="Attribute Values"
              // isDisabled={level === 'company'}
              onChange={(val: any) => {
                setFieldValue('overrideBlockedValues', val || []);
              }}
              isMulti
              creatable
              raw
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Allow Slices
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.allowSlices}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() => setFieldValue('allowSlices', !values.allowSlices)}
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Allow Splits
        </CardTitle>
        <Row>
          <Col xs={2} className="mt-3">
            <SwitchButton
              width={100}
              checked={!!values.allowSplits}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() => setFieldValue('allowSplits', !values.allowSplits)}
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Number of Times to Split a Lead
        </CardTitle>
        <Row>
          <Col xs={7} className="mt-3">
            <Field
              id="split-amount"
              name="splitCount"
              label="Split Amount"
              type="number"
              min={0}
              max={10}
              onBlur={({ target: { value } }) => {
                // Parse the value and ensure it's within the valid range
                let parsedValue = parseInt(value, 10);

                // Ensure it's a valid number
                if (isNaN(parsedValue)) {
                  parsedValue = 0; // Default to minimum if invalid
                }

                // Constrain between 0 and 10
                parsedValue = Math.max(0, Math.min(10, parsedValue));

                setFieldValue('splitCount', parsedValue);
                setFieldTouched('splitCount', true, true);
              }}
              helpMessage="Set the number of times to split into shared leads (0-10)"
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3 mb-4">
        <CardTitle tag="h4" className="lead text-uppercase">
          Split Active Demand Settings
        </CardTitle>
        <Row>
          {/* <SwitchButton
                width={120}
                checked={values.splitStopCountMinActiveDemand}
                onlabel="On"
                offlabel="Off"
                onstyle="success"
                offstyle="primary"
                onChange={() => {
                  setFieldValue(
                    'splitStopCountMinActiveDemand',
                    (values.splitStopCountMinActiveDemand = !values.splitStopCountMinActiveDemand)
                  );
                }}
              /> */}
          <Col xs={4} className="ml-4">
            <Row> Active Demand Split Stop</Row>
            <Row className="mt-2">
              <SwitchButton
                width={120}
                checked={values.splitStopActiveDemand}
                onlabel="On"
                offlabel="Off"
                onstyle="success"
                offstyle="primary"
                onChange={() => {
                  setFieldValue(
                    'splitStopActiveDemand',
                    (values.splitStopActiveDemand = !values.splitStopActiveDemand)
                  );
                }}
              />
            </Row>
          </Col>

          <Col xs={6}>
            <SelectField
              id="active-demand-fallback-values"
              name="splitActiveDemandFallBack"
              options={[]}
              label="Non Split Override Categories"
              // isDisabled={level === 'company'}
              onChange={(val: any) => {
                setFieldValue('splitActiveDemandFallBack', val || []);
              }}
              isMulti
              creatable
              raw
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3 mb-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Cross Network Layers
        </CardTitle>
        <Col xs={5} className="ml-4">
          <SelectField
            id="attribute_val-crossnetwork-layer-values"
            name="crossNetworkLayers"
            options={[]}
            label="Cross Network Layers"
            // isDisabled={level === 'company'}
            onChange={(val: any) => {
              setFieldValue('crossNetworkLayers', val || []);
            }}
            isMulti
            creatable
            raw
          />
        </Col>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Tresstle Settings
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Reject Tresstle
            <SwitchButton
              width={100}
              checked={!!values.rejectTresstle}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('rejectTresstle', !values.rejectTresstle)
              }
            />
          </Col>
          <Col xs={3}>
            <Field
              id="reject-tresstle-percentage"
              name="tresstleScoreMin"
              label="Reject Tresstle Percentage"
              type="number"
              min={0}
              step="0.01"
              onBlur={({ target: { value } }) => {
                setFieldValue('tresstleScoreMin', parseInt(value, 0));
              }}
              helpMessage="Set min accepted Tresstle Score"
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Cross Network Splits
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Turn On
            <SwitchButton
              width={100}
              checked={!!values.crossNetworkSplit}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('crossNetworkSplit', !values.crossNetworkSplit)
              }
            />
          </Col>
          <Col xs={4} className="ml-4">
            <SelectField
              id="network-split-key"
              name="networkSplitKey"
              options={[]}
              label="Network Split Key"
              // isDisabled={level === 'company'}
              onChange={(val: any) => {
                setFieldValue('networkSplitKey', val || []);
              }}
              // isMulti
              creatable
              raw
            />
          </Col>
          <Col xs={2}>
            <Field
              id="min-network-split"
              name="minNetworkSplit"
              label="Min Split"
              type="number"
              min={0}
              step="0.01"
              onBlur={({ target: { value } }) => {
                setFieldValue('minNetworkSplit', parseInt(value, 0));
              }}
              helpMessage="Min that has to be accepted"
            />
          </Col>
          <Col xs={2}>
            <Field
              id="max-network-split"
              name="maxNetworkSplit"
              label="Max Split"
              type="number"
              min={0}
              step="0.01"
              onBlur={({ target: { value } }) => {
                setFieldValue(
                  'minNetmaxNetworkSplitorkSplit',
                  parseInt(value, 0)
                );
              }}
              helpMessage="Max allowed to be split"
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Deactivate Active Demand
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Active Demand Deactivation
            <SwitchButton
              width={100}
              checked={!!values.deactivateActiveDemand}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'deactivateActiveDemand',
                  !values.deactivateActiveDemand
                )
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Global Wildcard Filter
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Active Global Wildcard Filter
            <SwitchButton
              width={100}
              checked={!!values.globalWildCardFilter}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'globalWildCardFilter',
                  !values.globalWildCardFilter
                )
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Duplicate Check Level ID
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={4}>
            <Field
              id="dup-check-level-id"
              name="dupCheckLevelID"
              label="Duplicate Check Level ID"
              placeholder="Duplicate Check Level ID..."
              type="text"
              onBlur={({ target: { value } }) => {
                setFieldValue('dupCheckLevelID', value);
              }}
              helpMessage="The duplicate check Level ID for this lead channel"
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Vendor Price in Pennies
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Vendor Price in Pennies
            <SwitchButton
              width={100}
              checked={!!values.vendorPriceInPennies}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'vendorPriceInPennies',
                  !values.vendorPriceInPennies
                )
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Bot Detection
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Heyflow Bot Detection
            <SwitchButton
              width={100}
              checked={!!values.heyflowBotDetection}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'heyflowBotDetection',
                  !values.heyflowBotDetection
                )
              }
            />
          </Col>
          <Col xs={2}>
            Non USA Bot Detection
            <SwitchButton
              width={100}
              checked={!!values.nonusaBotDetection}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue('heyflowBotDetection', !values.nonusaBotDetection)
              }
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3 mb-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Active Demand Allow Threasholds
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Apply Override Filter
            <SwitchButton
              width={100}
              checked={!!values.applyOverrideFilter}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'applyOverrideFilter',
                  !values.applyOverrideFilter
                )
              }
            />
          </Col>
          <Col xs={3}>
            <Field
              id="ad-income-max"
              name="adIncomeMax"
              label="Income Max"
              type="number"
              min={0}
              step="1"
              onBlur={({ target: { value } }) => {
                setFieldValue('adIncomeMax', parseFloat(value));
              }}
              helpMessage="Set the max income to allow active demand"
            />
          </Col>
          <Col xs={3}>
            <Field
              id="ad-household-max"
              name="adHouseHoldMax"
              label="HouseHold Max"
              type="number"
              min={0}
              step="1"
              onBlur={({ target: { value } }) => {
                setFieldValue('adHouseHoldMax', parseFloat(value));
              }}
              helpMessage="Set the household max to allow active demand. This will be used in conjunction with Income Max if greater than 0"
            />
          </Col>
        </Row>
      </Card>
      <Card body className="mt-3 mb-3">
        <CardTitle tag="h4" className="lead text-uppercase">
          Vendor Profiles
        </CardTitle>
        <Row className="mt-3 ml-1">
          <Col xs={2}>
            Agent Profile Assignment Allowed
            <SwitchButton
              width={100}
              checked={!!values.agentProfileAssigmentAllowed}
              onlabel="Enabled"
              offlabel="Disabled"
              onstyle="success"
              offstyle="danger"
              onChange={() =>
                setFieldValue(
                  'agentProfileAssigmentAllowed',
                  !values.agentProfileAssigmentAllowed
                )
              }
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default OtherCard;
